import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { DragHandle } from "presentation/components/draggable-table/draggable-handler";
import styled from "styled-components";

const DraggingRow = styled.td`
  background: rgba(127, 207, 250, 0.3);
`;

const TableData = styled.td`
  background: white;
  &:first-of-type {
   text-align: center;
   vertical-align: middle;
  }
`;

const removeKeyProp = (props) => {
  delete (props['key']);
  return { ...props };
}

export const DraggableTableRow = ({ row }) => {
  const {
    attributes,
    listeners,
    transform,
    transition,
    setNodeRef,
    isDragging
  } = useSortable({
    id: row.original.id
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition
  };
  return (
    <tr key={`tr-${Math.random()}`} ref={setNodeRef} style={style} {...removeKeyProp({ ...row.getRowProps() })}>
      {isDragging ? (
        <DraggingRow colSpan={row.cells.length}>&nbsp;</DraggingRow>
      ) : (
        row.cells.map((cell, i) => {
          if (i === 0) {
            return (
              <TableData key={`td-${Math.random()}`}  {...removeKeyProp({ ...cell.getCellProps() })}>
                <DragHandle {...attributes} {...listeners} />
                <span>{cell.render("Cell")}</span>
              </TableData>
            );
          }
          return (
            <TableData key={`td-${Math.random()}`}  {...removeKeyProp({ ...cell.getCellProps() })}>
              {cell.render("Cell")}
            </TableData>
          );
        })
      )}
    </tr>
  );
};
